import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import { ProfileSettings } from "./modules/profile_settings";
import { CandidatesMaster } from "./modules/candidates_master/pages/candidatesMaster";
import ViewCandidatesMaster from "./modules/candidates_master/pages/viewCandidatesMaster";
import ColdLeadCallDetails from "./modules/candidates_master/pages/CallDetails";
import UpdateSubUser from "./modules/users/pages/createUser";
import { Users } from "./modules/users";
import { useIsAccessAllow } from "./modules/users/redux";
import SettingsPage from "./modules/settings/pages/Settings";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/profile-settings" component={ProfileSettings} />
        <ContentRoute
          exact
          path="/user"
          component={Users}
          title="Users"
          isAccessAllow={useIsAccessAllow("user.list")}
        />
        <ContentRoute
          exact
          path="/user/add-user"
          component={UpdateSubUser}
          title="Add User"
          isAccessAllow={useIsAccessAllow("user.add_user")}
        />
        <ContentRoute
          exact
          path="/user/edit-user/:id"
          component={UpdateSubUser}
          title="Update User"
          isAccessAllow={useIsAccessAllow("user.edit_user")}
        />
        <ContentRoute
          exact
          path="/candidates-master"
          component={CandidatesMaster}
          isAccessAllow={useIsAccessAllow("candidatemaster.list")}
        />
        <ContentRoute
          exact
          path="/candidates-master/view/:id"
          component={ViewCandidatesMaster}
          isAccessAllow={useIsAccessAllow("candidatemaster.view")}
        />
        <ContentRoute
          exact
          path="/candidates-master/call-details/:id"
          component={ColdLeadCallDetails}
          isAccessAllow={useIsAccessAllow("candidatemaster.view")}
        />
        <ContentRoute
          exact
          path="/settings"
          component={SettingsPage}
          isAccessAllow={useIsAccessAllow("settings.*")}
        />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
